import React, { memo } from "react";
import { Redirect, Route as RRoute, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { useUserState } from "@features/User/context";
import { showLanding } from "@core/utils";

function Route({ authorize, publicAccess, children, ...rest }) {
  const { authorized, isLoading } = useUserState();
  const { pathname } = useLocation();
  const landingEnabled = showLanding();

  return (
    <RRoute
      {...rest}
      render={({ location }) => {
        if (authorize && !authorized && !isLoading && pathname !== "/login") {
          return (
            <Redirect
              to={{
                pathname: "/login",
                state: { from: location },
              }}
            />
          );
        } else if (!authorize && authorized && !publicAccess) {
          return (
            <Redirect
              to={{
                pathname: "/dashboard/profile",
                state: { from: location },
              }}
            />
          );
        } else if (pathname === "/") {
          if (!landingEnabled || authorized) {
            return (
              <Redirect
                to={{
                  pathname: "/dashboard/profile",
                  state: { from: location },
                }}
              />
            );
          }
        }

        return children;
      }}
    />
  );
}

Route.propTypes = {
  authorize: PropTypes.bool,
  publicAccess: PropTypes.bool,
};

export default memo(Route);
